enum CountryCode {
    unitedStates = 'US',
    australia = 'AU',
    newZealand = 'NZ',
    netherlands = 'NL',
}

// App-wide default region, used when no user profile/region is known.
const DEFAULT_COUNTRY = CountryCode.australia;

export { CountryCode, DEFAULT_COUNTRY };
